import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_281: DocMigration = {
  maxSchemaVersion: "0.0.281",
  description: "Move Gable Belly Band Settings to roofSideOverrides",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofSettings = {} } = roof;
      let { roofSideOverrides = {} } = roof;
      const {
        gableBellyBandBoard,
        gableBellyBandBoardAnchor,
        gableBellyBandBoardJustification,
        gableBellyBandBoardOffset,
      } = roofSettings;
      roofSideOverrides = {
        ...roofSideOverrides,
        START: {
          ...roofSideOverrides.START,
          gableBellyBandBoard,
          gableBellyBandBoardAnchor,
          gableBellyBandBoardJustification,
          gableBellyBandBoardOffset,
        },
        END: {
          ...roofSideOverrides.END,
          gableBellyBandBoard,
          gableBellyBandBoardAnchor,
          gableBellyBandBoardJustification,
          gableBellyBandBoardOffset,
        },
      };

      delete roofSettings.gableBellyBandBoard;
      delete roofSettings.gableBellyBandBoardAnchor;
      delete roofSettings.gableBellyBandBoardJustification;
      delete roofSettings.gableBellyBandBoardOffset;

      roofs[id] = {
        ...roof,
        roofSideOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_281;
